var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4189 9.03779C50.7461 -1.65423 35.2425 -3.3805 20.2265 6.66982C19.6124 7.08557 18.6463 7.89899 18.0774 8.60396H18.1316C19.3596 7.57362 21.4545 6.92288 23.459 6.92288H38.8543C41.0665 6.92288 42.7008 7.41998 43.7663 8.4232C44.8318 9.41739 45.3645 10.7008 45.3645 12.2644C45.3645 13.828 44.8228 15.1385 43.7392 16.1417C42.6557 17.1359 41.0304 17.633 38.8453 17.633H27.6035V25.0713H36.4344C38.6466 25.0713 40.2809 25.5684 41.3554 26.5716C42.3126 27.4664 42.8453 28.5961 42.9356 29.9518C42.9446 30.0964 42.9537 30.2501 42.9537 30.4128C42.9537 30.5755 42.9537 30.7201 42.9356 30.8647C42.8363 32.2475 42.3126 33.3863 41.3374 34.2901C40.2538 35.2933 38.6285 35.7904 36.4344 35.7904H27.6035V51.6884C31.7661 51.0015 35.9919 50.8297 43.1613 46.148C58.2948 36.2785 63.7305 19.1966 57.4099 9.0649L57.4189 9.03779ZM17.8156 57.2558C16.8133 56.1712 16.3167 54.5444 16.3167 52.3572V15.3283C2.18554 25.713 -3.93646 41.4844 2.64604 51.3449C6.39328 56.9575 13.4995 59.4701 21.6802 58.9278V58.9007C20.1 58.9007 18.8088 58.3404 17.8065 57.2558H17.8156Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.898f63aebe9c66c55787b3f7442316fc.svg";
export { ForwardRef as ReactComponent };